import { useEffect, useRef, useState } from "react";
import { getChildNames } from "../../../services/dataService";
import { childKey } from "../../../utils/lessonPresentation";

// The children behind a page of a tutor's lessons, in SessionsTable's `childrenById` shape
// ({ childId: { name } }). Each child is asked for once while the tab stays mounted; a child
// getChildNames cannot read is absent, and its row says "Child".
export const useChildNames = (rows) => {
  const asked = useRef(new Set());
  const [children, setChildren] = useState({});
  const key = [...new Set((rows || []).map(childKey).filter((k) => k && !asked.current.has(k)))].join(",");
  useEffect(() => {
    if (!key) return;
    const keys = key.split(",");
    keys.forEach((k) => asked.current.add(k));
    // A Firestore id never holds "/", so the key splits back into its two ids.
    getChildNames(keys.map((k) => ({ parentId: k.split("/")[0], childId: k.split("/")[1] }))).then((names) =>
      setChildren((prev) => {
        const next = { ...prev };
        Object.entries(names).forEach(([k, name]) => {
          next[k.split("/")[1]] = { name };
        });
        return next;
      })
    );
  }, [key]);
  return children;
};
